
import React, { useState }  from 'react';
import axios from 'axios';
import {  Alert, Container, Col, Form, Row, FormGroup, Label, Input, Button, FormText } from 'reactstrap';

import  SelectGenero  from './Reusables/SelectGenero';
import SelectVivienda from './Reusables/SelectTipoVivienda';
import AuthorizeRoute from './api-authorization/AuthorizeRoute';
import ApiAuthorizationRoutes from './api-authorization/ApiAuthorizationRoutes';
import { ApplicationPaths } from './api-authorization/ApiAuthorizationConstants';
import authService from './api-authorization/AuthorizeService';
import ModalsAlert from './ModalsAlert';
import Tabs from './Tabs'



class addCredito extends React.Component {
  constructor(props) {
    super(props)
      this.state = {
          business: [],
          Id: 0,
          UserId:'',
          ApellidoP: '',
          ApellidoM: '',
          Nombres: '',
          Genero: '',
          lugar_Nacimiento: '',
          Nacionalidad: '',
          Pais_Nacimiento: '',
          RFC_Homoclave: '',
          CURP: '',
          Fecha_Nacimiento: '',
          Num_ident_Oficial_Vigente: '',
          Tipo: '',
          Correo: '',
          AddressDetail: '',
          CologneFractionation: '',
          NumExt: '',
          NumInt: '',
          City: '',
          PostalCode: '',
          DelegationMunicipality: '',
          State: '',
          Telf_Particular: '',
          Telf_Particular2: '',
          Cellphone: '',
          Cellphone2: '',
          MaximumDegreeStudies: '',
          MaritalStatus: '',
          SpousalRegime: '',
          NumEconomicDependents:'',
          FullNameSpouse: '',
          OccupationSpouse: '',
          BusinessSpouse: '',
          CellphoneSpouse: '',
          CompanyPhoneSpouse: '',
          TypeHousing: '',
          Otro: '',
          YearsResidence: 0,
          Empleador: '',
          TipodeEmpleo: '',
          labelTipo: 'Clave de Elector *',
          hidePasaporte:true,
          validadorForm:true,
          IngresosDeclaradosMensuales: 0,
          FechaIngreso: '',
          MontoSolicitado: 0,
          NumeroParcialidades:0,
          MontoPosibleApagar: 0,
          DestinodelCredito: '',
          OtroDestinodelCredito: '',
          hideOtroDestinodelCredito: true,
          hideOtroTypeHousing: true,
          statusEdoCivil: true,
          StatusCartapoder:true,
          UsoCredito: '',
          NombreCompleto1: '',
          Parentesco1: '',
          TelfLd1: '',
          Telefono1: '',
          TelfExt1: '',
          NombreCompleto2: '',
          Parentesco2: '',
          TelfLd2: '',
          Telefono2: '',
          TelfExt2: '',
          NombreCompleto3: '',
          Parentesco3: '',
          TelfLd3: '',
          Telefono3: '',
        TelfExt3: '',
        Estado: '',
        FechaModificacion: '',
          Firma: '',
           NumAleatorio:10000,
          aceptarCondiciones: false,
          CartaPoder: false,
          errors: {},
          Catalogo: [],
          Avisos: [],
          bloquearCiudad: 'disabled',
          Sepomex: [],
          mensajeModal: '',
          ValidadorSMS: '',
          UbicacionPersona: '',
          validadorTab1Class: "textoCentrado navActiveButton ActivarMenuItem",
          validadorTab2Class: "textoCentrado navActiveButton ",
          validadorTab3Class: "textoCentrado navActiveButton ",
          validadorTab4Class: "textoCentrado navActiveButton ",
          validadorTab5Class: "textoCentrado navActiveButton ",
          validadorTab6Class: "textoCentrado navActiveButton ",
          validadorTab7Class: "textoCentrado navActiveButton ",
          validadorTab8Class: "textoCentrado navActiveButton ",
          LatitudAPI: '',
          UbicacionAPI:'',
          LongitudAPI: '',
          Intentos: 0,
          FechaVencimiento:'',
          modal: false,
          deviceUSer:'',
          UploadInProcess: false,
          MensajeValidador: 'Solicitar código',
          hideinputSMS: true,
          hideTextSMS: false,
          hideBTNinputSMS: false,
          hidetextSMS: true,
          hidevalidateBTN: true,
          hideAprobado: true,
          hideEncurso: false,
          hidebtnEditartelf: true,
          validateTableAlert:true,
         
      }
      this.sendDataServer = this.sendDataServer.bind(this)
      this.CerrarModal = this.CerrarModal.bind(this)
    
      this.BuscarCatalogo = this.BuscarCatalogo.bind(this)

    
  }
    componentDidMount() {

        this.BuscarCatalogo();
   
        this.GenerarCodigo();
        this._subscription = authService.subscribe(() => this.populateState2());
        this.populateState2();
        console.log(authService);

       
        console.log(this.state)

        ///



       
        axios.get('GetSaS')
            .then(response => {
                var azure = response.data.split('@')
                window.sas = azure[0];
                window.account = azure[1];

                var validador = window.checkParameters()


                if (validador == true) {
                    window.getBlobService()
                    //    window.refreshContainer()
                    window.viewContainer(azure[2])
                    window.GetTemplate("Template/AutorizacionSolicitarReportesCredito.pdf", "Template", 1, "Descargar Autorización Reporte de Crédito");
                    window.GetTemplate("Template/AutorizaciónDomiciliaciondePagos.docx", "TemplateADP", 1, "Descargar Autorización domiciliacion de pagos");
                    var element, name, arr;
                    element = document.querySelectorAll('#root> div > div > .container')[0]
                    name = "contenedorAddCredito";
                    arr = element.className
                    if (arr.indexOf(name) == -1) {
                        element.className += " " + name;
                    }

                }

           
            })
            .catch(function (error) {
                console.log(error);
            })

        

        //this.BuscarUbicacion();

        
    }
    async populateState2() {
        const [isAuthenticated, user] = await Promise.all([authService.isAuthenticated(), authService.getUser()])
        console.log(user)
        this.state.UserId = user.sub
        this.GetUserCurrent()
      //  window.refreshBlobList(this.state.UserId)
    }
 

  cancelarPantalla = () => {

    let validacion = window.confirm("¿Está seguro que desea cancelar la solicitud?. Se perderán los cambios no guardados");
      if (validacion == true) {
          if (this.state.Id == 0) {

              window.history.back();
        } else {
              alert("se eliminaran los blow")

        }
    // this.props.history.push('/VerCreditos')
    
    } else {

    }
  }
    GetUserCurrent = () => {

        axios.get('/Api/Usuario/Usuariodetails?idUsuario=' + this.state.UserId)
            .then(response => {
                console.log(response);
                console.log(response.data);
                this.setState({
                    ApellidoP: response.data.lastName,
                    Empleador: response.data.company,
                    Nombres: response.data.name,
                    ApellidoM: response.data.secondLastName,
                    Genero: response.data.gender  ,
                    lugar_Nacimiento: response.data.cityofBirth  ,
                    Nacionalidad: response.data.nationality  ,
                    Pais_Nacimiento: response.data.countryofBirth  ,
                    RFC_Homoclave: response.data.rfc  ,
                    CURP: response.data.curp  ,
                    Fecha_Nacimiento: response.data.dob  ,
                    Num_ident_Oficial_Vigente: response.data.officialIdNumber  ,
                    Tipo: response.data.officialIdType  ,
                    Correo: response.data.email,  
                    Telf_Particular: response.data.phoneNumber,  
         
                    OfficialIdNumber2: response.data.officialIdNumber2,
                    OfficialIdNumber3: response.data.officialIdNumber3
                })


                if (this.state.Tipo == "INE/IFE") {

                    this.setState({
                        labelTipo: "Clave de Elector*",
                        hidePasaporte: false
                    })
                } else {

                    this.setState({
                        labelTipo: "Número de Pasaporte*",
                        hidePasaporte: true
                    })
                }
                //alert(response.data.dob)
                var fecha = response.data.dob.split('T')
                var fechaFinal = fecha[0].split('-')
                this.setState({
                    Fecha_Nacimiento: fechaFinal[2] + '-' + fechaFinal[1] + '-' + fechaFinal[0]
                    
                    })
             
                this.buscarSolicitudes()
            })
            .catch(function (error) {
                console.log(error);
            })
        //
    }


    BuscarAviso() {

        axios.get('/Api/Settings/GetAvisos')
            .then(response => {


                this.setState({ Avisos: response.data });
                console.log(this.state.Avisos)

            })
            .catch(function (error) {
                console.log(error);
            })


    }


    BuscarCatalogo() {
       
        axios.get('/Api/Settings/GetCatalogo')
            .then(response => {

                
                this.setState({ Catalogo: response.data });
                console.log(this.state.Catalogo)
                this.BuscarAviso();
            })
            .catch(function (error) {
                console.log(error);
            })

       
    }
    

            handleChangePostalCode = (value, name, props) => {

        //alert('el codigo introducido es el ' + this.state.PostalCode)


                if (value== '') {

            alert(this.state.PostalCode + " is not a number <br/>");
        } else {

              if (isNaN(value)) {
                  alert(value + " no es un codigo postal.<br/>");
                this.setState({ PostalCode: '' });

                this.setState({ State: ''})
                this.setState({ DelegationMunicipality: '' })
                this.setState({ City: '' })

            } else {
                //alert(this.state.PostalCode + " is a number <br/>");
                this.BuscarCodigoPostalSEPOMEX(value)
            }

        }
       
    }


 

    BuscarCodigoPostalSEPOMEX(value) {
      //  alert(this.state.PostalCode + "buscando");
        axios.get('/Api/Settings/Sepomex?id=' + value)
            .then(response => {
                console.log(response.data)


                this.setState({ Sepomex: response.data });

              

                if (response.data.length > 0) {

                    this.setState({ State: response.data[0].dEstado })
                    this.setState({ DelegationMunicipality: response.data[0].dMnpio })

                    if (response.data[0].dCiudad == "" || response.data[0].dCiudad == null || response.data[0].dCiudad == "null") {
                        this.setState({ bloquearCiudad: '' })
                        this.setState({ City: '' })
                    } else {
                        this.setState({ bloquearCiudad: 'disabled' })
                        this.setState({ City: response.data[0].dCiudad })
                    }
                } else {
                    this.setState({ State: ''  })
                    this.setState({ City: '' })
                    this.setState({ DelegationMunicipality: '' })

                    this.setState({
                        mensajeModal: "CodigoPostal"

                    })

                    this.setState({
                        modal: true

                    })
                }
              
             
                
                console.log(response.data )

            })
            .catch(function (error) {
                console.log(error);
            })


    }
    

    buscarSolicitudes = () => {

        axios.get('/Api/Credito/CreditodetailsUsuario?idEmpleado=' + this.state.UserId)
            .then(response => {
      
               
                if (this.verificarSolicitudes(response) == true) {
                   // alert("Usted ya tiene una solicitud en proceso. Solo se permite una solicitud activa a la vez.")
               
                    //
               
                this.setState({
                    mensajeModal: "Usted ya tiene una solicitud en proceso. Solo se permite una solicitud activa a la vez."

                })

                this.setState({
                    modal: true

                })
                }
    
            })
            .catch(function (error) {
                console.log(error);
            })
    }


    verificarSolicitudes(response) {
        console.log(response.data[0])
        for (var i = 0; i < response.data.length; i++) {
            console.log(response.data[i].estado)
            if (response.data[i].estado == "GUARDADO" || response.data[i].estado == "GUARDADO POR EL SISTEMA" || response.data[i].estado == "EN REVISIÓN"
                || response.data[i].estado == "REQUIERE CAMBIOS"
                || response.data[i].estado == "EN REVISIÓN FIRMA Y SELFIE" || response.data[i].estado == "CONTRATO ANEXADO"
                || response.data[i].estado == "REQUIERE CAMBIOS EN FIRMA O SELFIE") {
                this.setState({ EstadoSolicitudEnProceso: true })
                return true;
            }

        }
        return false;

    }



    CerrarModal = () => {
        if (this.state.mensajeModal == "Usted ya tiene una solicitud en proceso. Solo se permite una solicitud activa a la vez.") {


            this.props.history.push('/')
        } else {
this.setState({
            modal: false

        })
        }
        
    }



    getUserDeviceInfo = () => {



        var module = {
            options: [],
            header: [navigator.platform, navigator.userAgent, navigator.appVersion, navigator.vendor, window.opera],
            dataos: [
                { name: 'Windows Phone', value: 'Windows Phone', version: 'OS' },
                { name: 'Windows', value: 'Win', version: 'NT' },
                { name: 'iPhone', value: 'iPhone', version: 'OS' },
                { name: 'iPad', value: 'iPad', version: 'OS' },
                { name: 'Kindle', value: 'Silk', version: 'Silk' },
                { name: 'Android', value: 'Android', version: 'Android' },
                { name: 'PlayBook', value: 'PlayBook', version: 'OS' },
                { name: 'BlackBerry', value: 'BlackBerry', version: '/' },
                { name: 'Macintosh', value: 'Mac', version: 'OS X' },
                { name: 'Linux', value: 'Linux', version: 'rv' },
                { name: 'Palm', value: 'Palm', version: 'PalmOS' }
            ],
            databrowser: [
                { name: 'Chrome', value: 'Chrome', version: 'Chrome' },
                { name: 'Firefox', value: 'Firefox', version: 'Firefox' },
                { name: 'Safari', value: 'Safari', version: 'Version' },
                { name: 'Internet Explorer', value: 'MSIE', version: 'MSIE' },
                { name: 'Opera', value: 'Opera', version: 'Opera' },
                { name: 'BlackBerry', value: 'CLDC', version: 'CLDC' },
                { name: 'Mozilla', value: 'Mozilla', version: 'Mozilla' }
            ],
            init: function () {
                var agent = this.header.join(' '),
                    os = this.matchItem(agent, this.dataos),
                    browser = this.matchItem(agent, this.databrowser);

                return { os: os, browser: browser };
            },
            matchItem: function (string, data) {
                var i = 0,
                    j = 0,
                    html = '',
                    regex,
                    regexv,
                    match,
                    matches,
                    version;

                for (i = 0; i < data.length; i += 1) {
                    regex = new RegExp(data[i].value, 'i');
                    match = regex.test(string);
                    if (match) {
                        regexv = new RegExp(data[i].version + '[- /:;]([\\d._]+)', 'i');
                        matches = string.match(regexv);
                        version = '';
                        if (matches) { if (matches[1]) { matches = matches[1]; } }
                        if (matches) {
                            matches = matches.split(/[._]+/);
                            for (j = 0; j < matches.length; j += 1) {
                                if (j === 0) {
                                    version += matches[j] + '.';
                                } else {
                                    version += matches[j];
                                }
                            }
                        } else {
                            version = '0';
                        }
                        return {
                            name: data[i].name,
                            version: parseFloat(version)
                        };
                    }
                }
                return { name: 'unknown', version: 0 };
            }
        };

        var e = module.init(),
            debug = '';


        debug += 'os.name:' + e.os.name + ' |-| ';
        debug += 'os.version:' + e.os.version + ' |-| ';
        debug += 'browser.name:' + e.browser.name + ' |-| ';
        debug += 'browser.version:' + e.browser.version + ' |-| ';
        debug += 'navigator.userAgent:' + navigator.userAgent + ' |-| ';
        debug += 'navigator.appVersion:' + navigator.appVersion + ' |-| ';
        debug += 'navigator.platform:' + navigator.platform + ' |-| ';
        debug += 'navigator.vendor:' + navigator.vendor;


        this.setState({ deviceUSer: debug })
    }
    ValidateForm = () => {


        this.setState({ validadorTab6Class: 'textoCentrado navActiveButton ActivarMenuItem' })
        this.setState({ validadorTab7Class: 'textoCentrado navActiveButton ActivarMenuItem' })
        this.setState({ validadorTab8Class: 'textoCentrado navActiveButton ActivarMenuItem' })


        this.setState({ UbicacionAPI: document.getElementById('UbicacionAPI').value })

        this.setState({ LongitudAPI: document.getElementById('LongitudAPI').value })
        this.setState({ LatitudAPI: document.getElementById('LatitudAPI').value})
        console.log(document.getElementById('UbicacionAPI').value)

        console.log(this.state)

       
              //        this.setState({
              //            mensajeModal: "ValidarSMS"

              //})
              //this.setState({
              //    modal: true

              //})


       
     

        if (document.getElementById('LongitudAPI').value == "" ||
            document.getElementById('LatitudAPI').value == "" ||
            document.getElementById('UbicacionAPI').value == "" ) {

            this.setState({ validadorTab8Class: 'textoCentrado navActiveButton ActivarRojo ActivarMenuItem' })
        }
       
          
       this.VAlidarCamposForm()



        if (this.state.Firma !== this.state.Nombres.toString().toUpperCase() + " " + this.state.ApellidoP.toString().toUpperCase() + " " + this.state.ApellidoM.toString().toUpperCase()) {
            // alert('Para continuar debe escribir su nombre(s) y apellido(s) igual al registrado en el sistema');
            this.setState({ validadorTab7Class: 'textoCentrado navActiveButton ActivarRojo ActivarMenuItem' })
        }



      console.log(document.querySelectorAll('.intent').length)
      if (document.querySelectorAll('.intent0').length <= 0 || document.querySelectorAll('.intent1').length <= 0
          || document.querySelectorAll('.intent2').length <= 0 || document.querySelectorAll('.intent4').length <= 0
          || document.querySelectorAll('.intent8').length <= 0 || document.querySelectorAll('.intent9').length <= 0
        //  || (this.state.CartaPoder == true && document.querySelectorAll('.intent10').length <= 0)
      ) {

          this.setState({ validadorTab6Class: 'textoCentrado navActiveButton ActivarRojo ActivarMenuItem' })

              this.setState({
                  mensajeModal: "Debe adjuntar los documentos requeridos "

              })
              this.setState({
                  modal: true

              })

          
        

          
        
      }
      else {

      
     
          if (this.state.Firma.toUpperCase() !== this.state.Nombres.toString().toUpperCase() + " " + this.state.ApellidoP.toString().toUpperCase() + " " + this.state.ApellidoM.toString().toUpperCase() ) {
       // alert('Para continuar debe escribir su nombre(s) y apellido(s) igual al registrado en el sistema');

        this.setState({
            mensajeModal: "Para continuar debe escribir su nombre(s) y apellido(s) igual al registrado en el sistema"

        })

        this.setState({
            modal: true

        })
    }
          else {

        if (this.state.aceptarCondiciones == true) {
           this.IniciarProceso()
            this.setState({ validadorTab7Class: 'textoCentrado navActiveButton ActivarMenuItem' })
        }
        else {
            this.setState({ validadorTab7Class: 'textoCentrado navActiveButton ActivarRojo ActivarMenuItem' })
            this.setState({
                mensajeModal: "Para continuar debe aceptar la Autorización para uso de la información"

            })

            this.setState({
                modal: true

            })
          //alert('Para continuar debe aceptar la Autorización para uso de la información.');

        }
          }
      }
  }

  SaveValidateForm = () => {


      if(this.state.Id == 0) {
          this.addCredito("GUARDADO");

      } else {

          this.UpdateCredito("GUARDADO");
      }
     

     
    
    }


    BuscarUbicacion() {
        //  alert(this.state.PostalCode + "buscando");
        axios.get('/Api/Credito/GetLastLocation?idsolicitud=' + this.state.IdSolicitud)
            .then(response => {
                console.log(response.data)


                if (response.data.length > 0) {
                    this.setState({ Intentos: response.data.intentos });
                    this.setState({ FechaVencimiento: response.data.fechaVencimiento });


                } else {
                    this.setState({ Intentos: 0 });
                    this.setState({ FechaVencimiento: new Date() });


                }



                console.log(this.state)


            })
            .catch(function (error) {
                console.log(error);
            });

        console.log(this.state)

    }

    addCredito(estadoSolicitud) {
        console.log(estadoSolicitud);
        const solicitud = {
            Id: parseInt(0),
            UserId: this.state.UserId
        };
        const address = {
            IdSolicitud: 0,

            AddressDetail: this.state.AddressDetail,
            CologneFractionation: this.state.CologneFractionation,
            PostalCode: this.state.PostalCode,
            NumExt: this.state.NumExt,
            NumInt: this.state.NumInt,
            PostalCode: this.state.PostalCode,
            DelegationMunicipality: this.state.DelegationMunicipality,
            State: this.state.State,
            Cellphone: this.state.Cellphone2,
            TypeHousing: this.state.TypeHousing,
            YearsResidence: parseInt(this.state.YearsResidence.toString())


        };
        const credito = {
            IdSolicitud: 0,
            MontoSolicitado: parseFloat(this.state.MontoSolicitado.toString()),
            NumeroParcialidades: parseFloat(this.state.NumeroParcialidades.toString()),
            MontoPosibleApagar: parseFloat(this.state.MontoPosibleApagar.toString()),
            UsoCredito: this.state.UsoCredito,
            Estado: estadoSolicitud,
            DestinodelCredito: this.state.DestinodelCredito,
            OtroDestinodelCredito: this.state.OtroDestinodelCredito,
            FechaModificacion: new Date()
        };

        const laboral = {
            IdSolicitud: 0,
            Empleador: this.state.Empleador,
            TipodeEmpleo: this.state.TipodeEmpleo,
            IngresosDeclaradosMensuales: parseFloat(this.state.IngresosDeclaradosMensuales.toString()),
            FechaIngreso: this.state.FechaIngreso
        };

        const referencias = {
            IdSolicitud: 0,
            NombreCompleto1: this.state.NombreCompleto1,
            Parentesco1: this.state.Parentesco1,
            TelfLd1: this.state.TelfLd1,
            Telefono1: this.state.Telefono1,
            TelfExt1: this.state.TelfExt1,
            NombreCompleto2: this.state.NombreCompleto2,
            Parentesco2: this.state.Parentesco2,
            TelfLd2: this.state.TelfLd2,
            Telefono2: this.state.Telefono2,
            TelfExt2: this.state.TelfExt2,
            NombreCompleto3: this.state.NombreCompleto3,
            Parentesco3: this.state.Parentesco3,
            TelfLd3: this.state.TelfLd3,
            Telefono3: this.state.Telefono3,
            TelfExt3: this.state.TelfExt3,
        };
        const demographic = {
            IdSolicitud: 0,
            MaximumDegreeStudies: this.state.MaximumDegreeStudies,
            MaritalStatus: this.state.MaritalStatus,
            SpousalRegime: this.state.SpousalRegime,
            NumEconomicDependents: this.state.NumEconomicDependents,
            FullNameSpouse: this.state.FullNameSpouse,
            OccupationSpouse: this.state.OccupationSpouse,
            BusinessSpouse: this.state.BusinessSpouse,
            CellphoneSpouse: this.state.CellphoneSpouse,
            CompanyPhoneSpouse: this.state.CompanyPhoneSpouse
        };
        var d = new Date()
        const ubicacion = {
            IdSolicitud: 0,
            Latitud: this.state.LatitudAPI,
            Longitud: this.state.LongitudAPI,
            Direccion: this.state.UbicacionAPI,
            InfoDevice: this.state.deviceUSer,
            Intentos: parseInt(this.state.Intentos),
            FechaVencimiento:  new Date()
        };
        const AspNetUsers = {
            IdSolicitud: 0,
            PhoneNumber: this.state.Telf_Particular
            
        };


        const obj = {
            solicitud: solicitud,
            credito: credito,
            laboral: laboral,
            referencias: referencias,
            address: address,
            demographic: demographic,
            ubicacion: ubicacion,
            AspNetUsers: AspNetUsers
        }
        console.log(obj)
        //carga de la solicitud
        axios.post('/Api/Credito/AddSolicitud/', obj).then(json => {
            console.log(json.data)
            //if (json.data.status === 'Success') {
            console.log(json.data.message);
            //    obj.credito.IdSolicitud = json.data.Message;
            this.setState({ ['Id']: json.data.id })
            //  this.props.history.push('/VerCreditos')

            //this.uploadBlobByStreamR
            //}

        }).catch(error => {
            console.log(error.response)
        });



    }



    SaveValidateFormAdjunto = (value, name, props) => {

        var btnaDjunto = value
        if (document.getElementById("files" + value).files.length == 0) {
     

            this.setState({
                mensajeModal: "No ha seleccionado un archivo."

            })

            this.setState({
                modal: true

            })
        }
        else {
           
            if (value == 0) {
                //this.wait(3000)
                this.setState({ UploadInProcess: true })

            } else {

                this.setState({ UploadInProcess: false })


            }
            this.addCreditoAdjunto("GUARDADO", btnaDjunto);

        }
    
       

    }
    addCreditoAdjunto(estadoSolicitud, btnaDjunto) {
       
        console.log(estadoSolicitud);
        const solicitud = {
            Id: parseInt(0),
            UserId: this.state.UserId
        };
        const address = {
            IdSolicitud: 0,

            AddressDetail: this.state.AddressDetail,
            CologneFractionation: this.state.CologneFractionation,
            PostalCode: this.state.PostalCode,
            NumExt: this.state.NumExt,
            NumInt: this.state.NumInt,
            PostalCode: this.state.PostalCode,
            DelegationMunicipality: this.state.DelegationMunicipality,
            State: this.state.State,
            Cellphone: this.state.Cellphone2,
            TypeHousing: this.state.TypeHousing,
            YearsResidence: parseInt(this.state.YearsResidence.toString())


        };
        const credito = {
            IdSolicitud: 0,
            MontoSolicitado: parseFloat(this.state.MontoSolicitado.toString()),
            NumeroParcialidades: parseFloat(this.state.NumeroParcialidades.toString()),
            MontoPosibleApagar: parseFloat(this.state.MontoPosibleApagar.toString()),
            UsoCredito: this.state.UsoCredito,
            Estado: estadoSolicitud,
            DestinodelCredito: this.state.DestinodelCredito,
            OtroDestinodelCredito: this.state.OtroDestinodelCredito,
            FechaModificacion: new Date()
        };

        const laboral = {
            IdSolicitud: 0,
            Empleador: this.state.Empleador,
            TipodeEmpleo: this.state.TipodeEmpleo,
            IngresosDeclaradosMensuales: parseFloat(this.state.IngresosDeclaradosMensuales.toString()),
            FechaIngreso: this.state.FechaIngreso
        };

        const referencias = {
            IdSolicitud: 0,
            NombreCompleto1: this.state.NombreCompleto1,
            Parentesco1: this.state.Parentesco1,
            TelfLd1: this.state.TelfLd1,
            Telefono1: this.state.Telefono1,
            TelfExt1: this.state.TelfExt1,
            NombreCompleto2: this.state.NombreCompleto2,
            Parentesco2: this.state.Parentesco2,
            TelfLd2: this.state.TelfLd2,
            Telefono2: this.state.Telefono2,
            TelfExt2: this.state.TelfExt2,
            NombreCompleto3: this.state.NombreCompleto3,
            Parentesco3: this.state.Parentesco3,
            TelfLd3: this.state.TelfLd3,
            Telefono3: this.state.Telefono3,
            TelfExt3: this.state.TelfExt3,
        };
        const demographic = {
            IdSolicitud: 0,
            MaximumDegreeStudies: this.state.MaximumDegreeStudies,
            MaritalStatus: this.state.MaritalStatus,
            SpousalRegime: this.state.SpousalRegime,
            NumEconomicDependents: this.state.NumEconomicDependents,
            FullNameSpouse: this.state.FullNameSpouse,
            OccupationSpouse: this.state.OccupationSpouse,
            BusinessSpouse: this.state.BusinessSpouse,
            CellphoneSpouse: this.state.CellphoneSpouse,
            CompanyPhoneSpouse: this.state.CompanyPhoneSpouse
        };
        var d = new Date()
        const ubicacion = {
            IdSolicitud: 0,
            Latitud: this.state.LatitudAPI,
            Longitud: this.state.LongitudAPI,
            Direccion: this.state.UbicacionAPI,
            InfoDevice: this.state.deviceUSer,
            Intentos: parseInt(this.state.Intentos),
            FechaVencimiento:  new Date()
        };

        const AspNetUsers = {
            IdSolicitud: 0,
            PhoneNumber: this.state.Telf_Particular

        };

        const obj = {
            solicitud: solicitud,
            credito: credito,
            laboral: laboral,
            referencias: referencias,
            address: address,
            demographic: demographic,
            ubicacion: ubicacion,
            AspNetUsers: AspNetUsers
        }
        console.log(obj)
        console.log(btnaDjunto)
        //carga de la solicitud
        //if (btnaDjunto > 0 && this.state.Id == 0) {
        //    this.wait(3000)
        //}
        if (btnaDjunto !== "") {
            if (this.state.Id == 0) {
                //this.wait(3000)

                this.setState({ UploadInProcess: true })

            } else {

                this.setState({ UploadInProcess: false })


            }
        }
        if (this.state.Id == 0) {
           
            axios.post('/Api/Credito/AddSolicitud/', obj).then(json => {
                console.log(json.data)

                console.log(json.data.message);


                this.setState({ ['Id']: json.data.id } )
                console.log()
                console.log(this.state)

                if (btnaDjunto !== "") {

                    window.uploadBlobByStream(false, this.state.UserId, btnaDjunto, json.data.id)



                    this.setState({ UploadInProcess: false })

                }
              

                

            }).catch(error => {
                console.log(error.response)
            });

        }


        else {
            if (btnaDjunto !== "") {
                window.uploadBlobByStream(false, this.state.UserId, btnaDjunto, this.state.Id)
            }
        }
       


    }
    wait(ms) {
        var start = new Date().getTime();
        var end = start;
        while (end < start + ms) {
            end = new Date().getTime();
        }
    }

    handleChangeMontoPosibleApagar = (value, name, props) => {
        this.setState({ [name]: value });
        var valorMontoaPagar = value;
        var MontoIngreso = props.state.IngresosDeclaradosMensuales

        if (MontoIngreso*0.30< valorMontoaPagar) {
           
            this.setState({
                mensajeModal: "El monto excede al permitido. El monto maximo a pagar debe ser menor o igual al 30% de los ingresos declarados mensuales"

            })

            this.setState({
                modal: true

            })
            this.setState({ [name]: 0 });
        }

    }


   


    

        //


    VAlidarCamposForm = () => {
        //  e.preventDefault();
        let error = {};
        let validador = true;
        this.setState({ errors: {} });

        this.setState({ validadorTab1Class: 'textoCentrado navActiveButton ActivarMenuItem' })
        this.setState({ validadorTab2Class: 'textoCentrado navActiveButton ActivarMenuItem' })
        this.setState({ validadorTab3Class: 'textoCentrado navActiveButton ActivarMenuItem' })
        this.setState({ validadorTab4Class: 'textoCentrado navActiveButton ActivarMenuItem' })
        this.setState({ validadorTab5Class: 'textoCentrado navActiveButton ActivarMenuItem' })
        this.setState({ validadorTab6Class: 'textoCentrado navActiveButton ActivarMenuItem' })
        this.setState({ validadorTab7Class: 'textoCentrado navActiveButton ActivarMenuItem' })
        this.setState({ validadorTab8Class: 'textoCentrado navActiveButton ActivarMenuItem' })

        if (this.state.FechaIngreso == "") {
            error["Error_FechaIngreso"] = "Debe seleccionar una fecha valida.";
            this.setState({ validadorTab3Class: 'textoCentrado navActiveButton ActivarRojo ActivarMenuItem' })
            this.setState({ errors: error });

            validador = false;
        }


        if (this.state.Genero == null) {
            error["Error_Genero"] = "Debe completar este campo.";
            this.setState({ errors: error });
            validador = false;
        }
        if (this.state.lugar_Nacimiento == null) {
            error["Error_lugar_Nacimiento"] = "Debe completar este campo.";
            this.setState({ errors: error });
            validador = false;
            this.setState({ validadorTab1: false });
            this.setState({ validadorTab1Class: 'textoCentrado navActiveButton ActivarRojo ActivarMenuItem' })


        }
        if (this.state.Nacionalidad == null) {
            error["Error_Nacionalidad"] = "Debe completar este campo.";
            this.setState({ errors: error });
            validador = false;
        }
        if (this.state.Pais_Nacimiento == null) {
            error["Error_Pais_Nacimiento"] = "Debe completar este campo.";
            this.setState({ errors: error });
            validador = false;
        }
        if (this.state.RFC_Homoclave == null) {
            error["Error_RFC_Homoclave"] = "Debe completar este campo.";
            this.setState({ errors: error });
            validador = false;
        }
        if (this.state.CURP == null) {
            error["Error_CURP"] = "Debe completar este campo.";
            this.setState({ errors: error });
            validador = false;
        }
        if (this.state.Fecha_Nacimiento == null) {
            error["Error_Fecha_Nacimiento"] = "Debe completar este campo.";
            this.setState({ errors: error });
            validador = false;
        }
        if (this.state.Num_ident_Oficial_Vigente == null) {
            error["Error_Num_ident_Oficial_Vigente"] = "Debe completar este campo.";
            this.setState({ errors: error });
            validador = false;
        }
        if (this.state.Tipo == null) {
            error["Error_Tipo"] = "Debe completar este campo.";
            this.setState({ errors: error });
            validador = false;
        }
        if (this.state.Telf_Particular == null) {
            error["Error_Telf_Particular"] = "Debe completar este campo.";
            this.setState({ errors: error });
            validador = false;
        }

        //if (this.state.Empleador == "") {
        //  error["Error_Empleador"] = "Debe completar este campo.";
        //  this.setState({ errors: error });
        //  validador = false;
        //}
        if (this.state.TipodeEmpleo == "") {
            error["Error_TipodeEmpleo"] = "Debe completar este campo.";
            this.setState({ validadorTab3Class: 'textoCentrado navActiveButton ActivarRojo ActivarMenuItem' })
            this.setState({ errors: error });
            validador = false;
        }
        if (this.state.IngresosDeclaradosMensuales == "") {
            error["Error_IngresosDeclaradosMensuales"] = "Debe completar este campo.";
            this.setState({ validadorTab3Class: 'textoCentrado navActiveButton ActivarRojo ActivarMenuItem' })
            this.setState({ errors: error });
            validador = false;
        }
        if (this.state.MontoSolicitado == "") {
            error["Error_MontoSolicitado"] = "Debe completar este campo.";
            this.setState({ validadorTab4Class: 'textoCentrado navActiveButton ActivarRojo ActivarMenuItem' })
            this.setState({ errors: error });
            validador = false;
        }
        if (this.state.NumeroParcialidades == "") {
            error["Error_NumeroParcialidades"] = "Debe completar este campo.";
            this.setState({ validadorTab4Class: 'textoCentrado navActiveButton ActivarRojo ActivarMenuItem' })
            this.setState({ errors: error });
            validador = false;
        }
        if (this.state.MontoPosibleApagar == "") {
            error["Error_MontoPosibleApagar"] = "Debe completar este campo.";
            this.setState({ validadorTab4Class: 'textoCentrado navActiveButton ActivarRojo ActivarMenuItem' })
            this.setState({ errors: error });
            validador = false;
        }
        if (this.state.UsoCredito == "") {
            error["Error_UsoCredito"] = "Debe completar este campo.";
            this.setState({ validadorTab4Class: 'textoCentrado navActiveButton ActivarRojo ActivarMenuItem' })
            this.setState({ errors: error });
            validador = false;
        }
        if (this.state.NombreCompleto1 == "") {
            error["Error_NombreCompleto1"] = "Debe completar este campo.";
            this.setState({ validadorTab5Class: 'textoCentrado navActiveButton ActivarRojo ActivarMenuItem' })
            this.setState({ errors: error });
            validador = false;
        }
        if (this.state.Parentesco1 == "") {
            error["Error_Parentesco1"] = "Debe completar este campo.";
            this.setState({ validadorTab5Class: 'textoCentrado navActiveButton ActivarRojo ActivarMenuItem' })
            this.setState({ errors: error });
            validador = false;
        }
        //if (this.state.TelfLd1 == "") {
        //  error["Error_TelfLd1"] = "Debe completar este campo.";
        //  this.setState({ errors: error });
        //  validador = false;
        //}
        if (this.state.Telefono1 == "") {
            error["Error_Telefono1"] = "Debe completar este campo.";
            this.setState({ validadorTab5Class: 'textoCentrado navActiveButton ActivarRojo ActivarMenuItem' })
            this.setState({ errors: error });
            validador = false;
        }
        //if (this.state.TelfExt1 == "") {
        //  error["Error_TelfExt1"] = "Debe completar este campo.";
        //  this.setState({ errors: error });
        //  validador = false;
        //}
        if (this.state.NombreCompleto2 == "") {
            error["Error_NombreCompleto2"] = "Debe completar este campo.";
            this.setState({ validadorTab5Class: 'textoCentrado navActiveButton ActivarRojo ActivarMenuItem' })
            this.setState({ errors: error });
            validador = false;
        }
        if (this.state.Parentesco2 == "") {
            error["Error_Parentesco2"] = "Debe completar este campo.";
            this.setState({ validadorTab5Class: 'textoCentrado navActiveButton ActivarRojo ActivarMenuItem' })
            this.setState({ errors: error });
            validador = false;
        }
        //if (this.state.TelfLd2 == "") {
        //  error["Error_TelfLd2"] = "Debe completar este campo.";
        //  this.setState({ errors: error });
        //  validador = false;
        //}
        if (this.state.Telefono2 == "") {
            error["Error_Telefono2"] = "Debe completar este campo.";
            this.setState({ validadorTab5Class: 'textoCentrado navActiveButton ActivarRojo ActivarMenuItem' })
            this.setState({ errors: error });
            validador = false;
        }
        //if (this.state.TelfExt2 == "") {
        //  error["Error_TelfExt2"] = "Debe completar este campo.";
        //  this.setState({ errors: error });
        //  validador = false;
        //}
        if (this.state.NombreCompleto3 == "") {
            error["Error_NombreCompleto3"] = "Debe completar este campo.";
            this.setState({ validadorTab5Class: 'textoCentrado navActiveButton ActivarRojo ActivarMenuItem' })
            this.setState({ errors: error });
            validador = false;
        }
        if (this.state.Parentesco3 == "") {
            error["Error_Parentesco3"] = "Debe completar este campo.";
            this.setState({ validadorTab5Class: 'textoCentrado navActiveButton ActivarRojo ActivarMenuItem' })
            this.setState({ errors: error });
            validador = false;
        }
        //if (this.state.TelfLd3 == "") {
        //  error["Error_TelfLd3"] = "Debe completar este campo.";
        //  this.setState({ errors: error });
        //  validador = false;
        //}
        if (this.state.Telefono3 == "") {
            error["Error_Telefono3"] = "Debe completar este campo.";
            this.setState({ validadorTab5Class: 'textoCentrado navActiveButton ActivarRojo ActivarMenuItem' })
            this.setState({ errors: error });
            validador = false;
        }
        //if (this.state.TelfExt3 == "") {
        //  error["Error_TelfExt3"] = "Debe completar este campo.";
        //  this.setState({ errors: error });
        //  validador = false;
        //}
        if (this.state.AddressDetail == "") {
            error["Error_AddressDetail"] = "Debe completar este campo.";
            this.setState({ validadorTab2Class: 'textoCentrado navActiveButton ActivarRojo ActivarMenuItem' })
            this.setState({ errors: error });
            validador = false;
        }

        if (this.state.City == "") {
            error["Error_City"] = "Debe completar este campo.";
            this.setState({ validadorTab2Class: 'textoCentrado navActiveButton ActivarRojo ActivarMenuItem' })
            this.setState({ errors: error });
            validador = false;
        }
        if (this.state.NumExt == "") {
            error["Error_NumExt"] = "Debe completar este campo.";
            this.setState({ validadorTab2Class: 'textoCentrado navActiveButton ActivarRojo ActivarMenuItem' })
            this.setState({ errors: error });
            validador = false;
        }
        if (this.state.NumInt == "") {
            error["Error_NumInt"] = "Debe completar este campo.";
            this.setState({ validadorTab2Class: 'textoCentrado navActiveButton ActivarRojo ActivarMenuItem' })
            this.setState({ errors: error });
            validador = false;
        }

        if (this.state.CologneFractionation == "") {
            error["Error_CologneFractionation"] = "Debe completar este campo.";
            this.setState({ errors: error });
            this.setState({ validadorTab2Class: 'textoCentrado navActiveButton ActivarRojo ActivarMenuItem' })
            validador = false;
        }
        if (this.state.PostalCode == "") {
            error["Error_PostalCode"] = "Debe completar este campo.";
            this.setState({ errors: error });
            this.setState({ validadorTab2Class: 'textoCentrado navActiveButton ActivarRojo ActivarMenuItem' })
            validador = false;
        }
        if (this.state.DelegationMunicipality == "") {
            error["Error_DelegationMunicipality"] = "Debe completar este campo.";
            this.setState({ validadorTab2Class: 'textoCentrado navActiveButton ActivarRojo ActivarMenuItem' })
            this.setState({ errors: error });
            validador = false;
        }
        if (this.state.State == "") {
            error["Error_State"] = "Debe completar este campo.";
            this.setState({ validadorTab2Class: 'textoCentrado navActiveButton ActivarRojo ActivarMenuItem' })
            this.setState({ errors: error });
            validador = false;
        }
       
        if (this.state.NumEconomicDependents == "") {
            error["Error_NumEconomicDependents"] = "Debe completar este campo.";
            this.setState({ errors: error });
            validador = false;
            this.setState({ validadorTab1: false });
            this.setState({ validadorTab1Class: 'textoCentrado navActiveButton ActivarRojo ActivarMenuItem' })


        }
       
        if (this.state.Otro == "" && this.state.TypeHousing == "Otro") {
            error["Error_Otro"] = "Debe completar este campo.";
            this.setState({ errors: error });
            validador = false;
        }
        if (this.state.YearsResidence == "") {
            error["Error_YearsResidence"] = "Debe completar este campo.";
            this.setState({ errors: error });
            validador = false;
        }


        if (this.state.MaximumDegreeStudies == "") {
            error["Error_MaximumDegreeStudies"] = "Debe seleccionar una opción.";
            this.setState({ errors: error });
            validador = false;
            this.setState({ validadorTab1: false });
            this.setState({ validadorTab1Class: 'textoCentrado navActiveButton ActivarRojo ActivarMenuItem' })


        }
        if (this.state.MaritalStatus == "") {
            error["Error_MaritalStatus"] = "Debe seleccionar una opción.";
            this.setState({ errors: error });
            validador = false;
            this.setState({ validadorTab1: false });
            this.setState({ validadorTab1Class: 'textoCentrado navActiveButton ActivarRojo ActivarMenuItem' })


        }


        if (this.state.TypeHousing == "") {
            error["Error_TypeHousing"] = "Debe seleccionar una opción.";
            this.setState({ validadorTab2Class: 'textoCentrado navActiveButton ActivarRojo ActivarMenuItem' })
            this.setState({ errors: error });
            validador = false;
        }
        if (this.state.DestinodelCredito == "") {
            error["Error_DestinodelCredito"] = "Debe seleccionar una opción.";
            this.setState({ validadorTab4Class: 'textoCentrado navActiveButton ActivarRojo ActivarMenuItem' })
            this.setState({ errors: error });
            validador = false;
        }

        if (this.state.YearsResidence == 0 || this.state.YearsResidence == "" || isNaN(this.state.YearsResidence) == true) {
            error["Error_YearsResidence"] = "Debe ingresar un monto mayor a 0";
            this.setState({ validadorTab2Class: 'textoCentrado navActiveButton ActivarRojo ActivarMenuItem' })
            this.setState({ errors: error });
            validador = false;
        }
        if (this.state.IngresosDeclaradosMensuales == 0 || this.state.IngresosDeclaradosMensuales == "" || isNaN(this.state.IngresosDeclaradosMensuales) == true) {
            error["Error_IngresosDeclaradosMensuales"] = "Debe ingresar un monto mayor a 0";
            this.setState({ errors: error });
            validador = false;
        }

        if (this.state.MontoSolicitado == 0 || this.state.MontoSolicitado == "" || isNaN(this.state.MontoSolicitado) == true) {
            error["Error_MontoSolicitado"] = "Debe ingresar un monto mayor a 0";
            this.setState({ errors: error });
            validador = false;
        }

        if (this.state.NumeroParcialidades == 0 || this.state.NumeroParcialidades == "" || isNaN(this.state.NumeroParcialidades) == true) {
            error["Error_NumeroParcialidades"] = "Debe ingresar un monto mayor a 0";
            this.setState({ errors: error });
            validador = false;
        }
        if (this.state.MontoPosibleApagar == 0 || this.state.MontoPosibleApagar == "" || isNaN(this.state.MontoPosibleApagar) == true) {
            error["Error_MontoPosibleApagar"] = "Debe ingresar un monto mayor a 0";
            this.setState({ errors: error });
            validador = false;
        }



    }
    IniciarProceso=()=>{
      //  e.preventDefault();
        let error = {};
        let validador = true;
        this.setState({ errors: {} });

        this.setState({ validadorTab1Class: 'textoCentrado navActiveButton ActivarMenuItem' })
        this.setState({ validadorTab2Class: 'textoCentrado navActiveButton ActivarMenuItem' })
        this.setState({ validadorTab3Class: 'textoCentrado navActiveButton ActivarMenuItem' })
        this.setState({ validadorTab4Class: 'textoCentrado navActiveButton ActivarMenuItem' })
        this.setState({ validadorTab5Class: 'textoCentrado navActiveButton ActivarMenuItem' })
   

        if (this.state.FechaIngreso == "") {
            error["Error_FechaIngreso"] = "Debe seleccionar una fecha valida.";
            this.setState({ validadorTab3Class: 'textoCentrado navActiveButton ActivarRojo ActivarMenuItem' })  
            this.setState({ errors: error });
            
            validador = false;
        }

        
        if (this.state.Genero == null) {
            error["Error_Genero"] = "Debe completar este campo.";
            this.setState({ errors: error });
            validador = false;
        }
        if (this.state.lugar_Nacimiento == null) {
            error["Error_lugar_Nacimiento"] = "Debe completar este campo.";
            this.setState({ errors: error });
            validador = false;
            this.setState({ validadorTab1: false });
            this.setState({ validadorTab1Class: 'textoCentrado navActiveButton ActivarRojo ActivarMenuItem' })


        }
        if (this.state.Nacionalidad == null) {
            error["Error_Nacionalidad"] = "Debe completar este campo.";
            this.setState({ errors: error });
            validador = false;
        }
        if (this.state.Pais_Nacimiento == null) {
            error["Error_Pais_Nacimiento"] = "Debe completar este campo.";
            this.setState({ errors: error });
            validador = false;
        }
        if (this.state.RFC_Homoclave == null) {
            error["Error_RFC_Homoclave"] = "Debe completar este campo.";
            this.setState({ errors: error });
            validador = false;
        }
        if (this.state.CURP == null) {
            error["Error_CURP"] = "Debe completar este campo.";
            this.setState({ errors: error });
            validador = false;
        }
        if (this.state.Fecha_Nacimiento == null) {
            error["Error_Fecha_Nacimiento"] = "Debe completar este campo.";
            this.setState({ errors: error });
            validador = false;
        }
        if (this.state.Num_ident_Oficial_Vigente == null) {
            error["Error_Num_ident_Oficial_Vigente"] = "Debe completar este campo.";
            this.setState({ errors: error });
            validador = false;
        }
        if (this.state.Tipo == null) {
            error["Error_Tipo"] = "Debe completar este campo.";
            this.setState({ errors: error });
            validador = false;
        }
        if (this.state.Telf_Particular == null) {
            error["Error_Telf_Particular"] = "Debe completar este campo.";
            this.setState({ errors: error });
            validador = false;
        }

    //if (this.state.Empleador == "") {
    //  error["Error_Empleador"] = "Debe completar este campo.";
    //  this.setState({ errors: error });
    //  validador = false;
    //}
    if (this.state.TipodeEmpleo == "") {
        error["Error_TipodeEmpleo"] = "Debe completar este campo.";
        this.setState({ validadorTab3Class: 'textoCentrado navActiveButton ActivarRojo ActivarMenuItem' })
      this.setState({ errors: error });
      validador = false;
    }
    if (this.state.IngresosDeclaradosMensuales == "") {
        error["Error_IngresosDeclaradosMensuales"] = "Debe completar este campo.";
        this.setState({ validadorTab3Class: 'textoCentrado navActiveButton ActivarRojo ActivarMenuItem' })
      this.setState({ errors: error });
      validador = false;
    }
    if (this.state.MontoSolicitado == "") {
        error["Error_MontoSolicitado"] = "Debe completar este campo.";
        this.setState({ validadorTab4Class: 'textoCentrado navActiveButton ActivarRojo ActivarMenuItem' })
      this.setState({ errors: error });
      validador = false;
    }
    if (this.state.NumeroParcialidades == "") {
        error["Error_NumeroParcialidades"] = "Debe completar este campo.";
        this.setState({ validadorTab4Class: 'textoCentrado navActiveButton ActivarRojo ActivarMenuItem' })  
      this.setState({ errors: error });
      validador = false;
    }
    if (this.state.MontoPosibleApagar == "") {
        error["Error_MontoPosibleApagar"] = "Debe completar este campo.";
        this.setState({ validadorTab4Class: 'textoCentrado navActiveButton ActivarRojo ActivarMenuItem' })
      this.setState({ errors: error });
      validador = false;
    }
    if (this.state.UsoCredito == "") {
        error["Error_UsoCredito"] = "Debe completar este campo.";
        this.setState({ validadorTab4Class: 'textoCentrado navActiveButton ActivarRojo ActivarMenuItem' })
      this.setState({ errors: error });
      validador = false;
    }
    if (this.state.NombreCompleto1 == "") {
        error["Error_NombreCompleto1"] = "Debe completar este campo.";
        this.setState({ validadorTab5Class: 'textoCentrado navActiveButton ActivarRojo ActivarMenuItem' })
      this.setState({ errors: error });
      validador = false;
    }
    if (this.state.Parentesco1 == "") {
        error["Error_Parentesco1"] = "Debe completar este campo.";
        this.setState({ validadorTab5Class: 'textoCentrado navActiveButton ActivarRojo ActivarMenuItem' })
      this.setState({ errors: error });
      validador = false;
    }
    //if (this.state.TelfLd1 == "") {
    //  error["Error_TelfLd1"] = "Debe completar este campo.";
    //  this.setState({ errors: error });
    //  validador = false;
    //}
    if (this.state.Telefono1 == "") {
        error["Error_Telefono1"] = "Debe completar este campo.";
        this.setState({ validadorTab5Class: 'textoCentrado navActiveButton ActivarRojo ActivarMenuItem' })
      this.setState({ errors: error });
      validador = false;
    }
    //if (this.state.TelfExt1 == "") {
    //  error["Error_TelfExt1"] = "Debe completar este campo.";
    //  this.setState({ errors: error });
    //  validador = false;
    //}
    if (this.state.NombreCompleto2 == "") {
        error["Error_NombreCompleto2"] = "Debe completar este campo.";
        this.setState({ validadorTab5Class: 'textoCentrado navActiveButton ActivarRojo ActivarMenuItem' })
      this.setState({ errors: error });
      validador = false;
    }
    if (this.state.Parentesco2 == "") {
        error["Error_Parentesco2"] = "Debe completar este campo.";
        this.setState({ validadorTab5Class: 'textoCentrado navActiveButton ActivarRojo ActivarMenuItem' })
      this.setState({ errors: error });
      validador = false;
    }
    //if (this.state.TelfLd2 == "") {
    //  error["Error_TelfLd2"] = "Debe completar este campo.";
    //  this.setState({ errors: error });
    //  validador = false;
    //}
    if (this.state.Telefono2 == "") {
        error["Error_Telefono2"] = "Debe completar este campo.";
        this.setState({ validadorTab5Class: 'textoCentrado navActiveButton ActivarRojo ActivarMenuItem' })
      this.setState({ errors: error });
      validador = false;
    }
    //if (this.state.TelfExt2 == "") {
    //  error["Error_TelfExt2"] = "Debe completar este campo.";
    //  this.setState({ errors: error });
    //  validador = false;
    //}
    if (this.state.NombreCompleto3 == "") {
        error["Error_NombreCompleto3"] = "Debe completar este campo.";
        this.setState({ validadorTab5Class: 'textoCentrado navActiveButton ActivarRojo ActivarMenuItem' })
      this.setState({ errors: error });
      validador = false;
    }
    if (this.state.Parentesco3 == "") {
        error["Error_Parentesco3"] = "Debe completar este campo.";
        this.setState({ validadorTab5Class: 'textoCentrado navActiveButton ActivarRojo ActivarMenuItem' })
      this.setState({ errors: error });
      validador = false;
    }
    //if (this.state.TelfLd3 == "") {
    //  error["Error_TelfLd3"] = "Debe completar este campo.";
    //  this.setState({ errors: error });
    //  validador = false;
    //}
    if (this.state.Telefono3 == "") {
        error["Error_Telefono3"] = "Debe completar este campo.";
        this.setState({ validadorTab5Class: 'textoCentrado navActiveButton ActivarRojo ActivarMenuItem' })
      this.setState({ errors: error });
      validador = false;
    }
    //if (this.state.TelfExt3 == "") {
    //  error["Error_TelfExt3"] = "Debe completar este campo.";
    //  this.setState({ errors: error });
    //  validador = false;
    //}
    if (this.state.AddressDetail == "") {
        error["Error_AddressDetail"] = "Debe completar este campo.";
        this.setState({ validadorTab2Class: 'textoCentrado navActiveButton ActivarRojo ActivarMenuItem' })
      this.setState({ errors: error });
      validador = false;
        }

        if (this.state.City == "") {
            error["Error_City"] = "Debe completar este campo.";
            this.setState({ validadorTab2Class: 'textoCentrado navActiveButton ActivarRojo ActivarMenuItem' })
            this.setState({ errors: error });
            validador = false;
        }
        if (this.state.NumExt == "") {
            error["Error_NumExt"] = "Debe completar este campo.";
            this.setState({ validadorTab2Class: 'textoCentrado navActiveButton ActivarRojo ActivarMenuItem' })
            this.setState({ errors: error });
            validador = false;
        }
        if (this.state.NumInt == "") {
            error["Error_NumInt"] = "Debe completar este campo.";
            this.setState({ validadorTab2Class: 'textoCentrado navActiveButton ActivarRojo ActivarMenuItem' })
            this.setState({ errors: error });
            validador = false;
        }

    if (this.state.CologneFractionation == "") {
      error["Error_CologneFractionation"] = "Debe completar este campo.";
        this.setState({ errors: error });
        this.setState({ validadorTab2Class: 'textoCentrado navActiveButton ActivarRojo ActivarMenuItem' })
      validador = false;
    }
    if (this.state.PostalCode == "") {
      error["Error_PostalCode"] = "Debe completar este campo.";
        this.setState({ errors: error });
        this.setState({ validadorTab2Class: 'textoCentrado navActiveButton ActivarRojo ActivarMenuItem' })
      validador = false;
    }
    if (this.state.DelegationMunicipality == "") {
        error["Error_DelegationMunicipality"] = "Debe completar este campo.";
        this.setState({ validadorTab2Class: 'textoCentrado navActiveButton ActivarRojo ActivarMenuItem' })  
      this.setState({ errors: error });
      validador = false;
    }
    if (this.state.State == "") {
        error["Error_State"] = "Debe completar este campo.";
        this.setState({ validadorTab2Class: 'textoCentrado navActiveButton ActivarRojo ActivarMenuItem' })
      this.setState({ errors: error });
      validador = false;
    }
    //if (this.state.Telf_Particular2 == "") {
    //  error["Error_Telf_Particular2"] = "Debe completar este campo.";
    //  this.setState({ errors: error });
    //  validador = false;
    //}
    //if (this.state.Cellphone == "") {
    //  error["Error_Cellphone"] = "Debe completar este campo.";
    //  this.setState({ errors: error });
    //  validador = false;
    //}
    //if (this.state.Cellphone2 == "") {
    //  error["Error_Cellphone2"] = "Debe completar este campo.";
    //  this.setState({ errors: error });
    //  validador = false;
    //}
    //if (this.state.MaximumDegreeStudies == "") {
    //  error["Error_MaximumDegreeStudies"] = "Debe completar este campo.";
    //  this.setState({ errors: error });
    //    validador = false;
    //    this.setState({ validadorTab1: false });
    //}
    //if (this.state.MaritalStatus == "") {
    //  error["Error_MaritalStatus"] = "Debe completar este campo.";
    //  this.setState({ errors: error });
    //  validador = false;
    //}
    //if (this.state.SpousalRegime == "") {
    //  error["Error_SpousalRegime"] = "Debe completar este campo.";
    //  this.setState({ errors: error });
    //  validador = false;
    //}
    if (this.state.NumEconomicDependents == "") {
      error["Error_NumEconomicDependents"] = "Debe completar este campo.";
      this.setState({ errors: error });
        validador = false;
        this.setState({ validadorTab1: false });
        this.setState({ validadorTab1Class: 'textoCentrado navActiveButton ActivarRojo ActivarMenuItem' })


    }
    //if (this.state.FullNameSpouse == "") {
    //  error["Error_FullNameSpouse"] = "Debe completar este campo.";
    //  this.setState({ errors: error });
    //  validador = false;
    //}
    //if (this.state.OccupationSpouse == "") {
    //  error["Error_OccupationSpouse"] = "Debe completar este campo.";
    //  this.setState({ errors: error });
    //  validador = false;
    //}
    //if (this.state.BusinessSpouse == "") {
    //  error["Error_BusinessSpouse"] = "Debe completar este campo.";
    //  this.setState({ errors: error });
    //  validador = false;
    //}
    //if (this.state.CellphoneSpouse == "") {
    //  error["Error_CellphoneSpouse"] = "Debe completar este campo.";
    //  this.setState({ errors: error });
    //  validador = false;
    //}
    //if (this.state.CompanyPhoneSpouse == "") {
    //  error["Error_CompanyPhoneSpouse"] = "Debe completar este campo.";
    //  this.setState({ errors: error });
    //  validador = false;
    //}
        if (this.state.Otro == "" && this.state.TypeHousing == "Otro") {
      error["Error_Otro"] = "Debe completar este campo.";
      this.setState({ errors: error });
      validador = false;
    }
    if (this.state.YearsResidence == "") {
      error["Error_YearsResidence"] = "Debe completar este campo.";
      this.setState({ errors: error });
      validador = false;
    }


        if (this.state.MaximumDegreeStudies == "") {
            error["Error_MaximumDegreeStudies"] = "Debe seleccionar una opción.";
            this.setState({ errors: error });
            validador = false;
            this.setState({ validadorTab1: false });
            this.setState({ validadorTab1Class: 'textoCentrado navActiveButton ActivarRojo ActivarMenuItem' })


        }
        if (this.state.MaritalStatus == "") {
            error["Error_MaritalStatus"] = "Debe seleccionar una opción.";
            this.setState({ errors: error });
            validador = false;
            this.setState({ validadorTab1: false });
            this.setState({ validadorTab1Class: 'textoCentrado navActiveButton ActivarRojo ActivarMenuItem' })


        }


        if (this.state.TypeHousing == "") {
            error["Error_TypeHousing"] = "Debe seleccionar una opción.";
            this.setState({ validadorTab2Class: 'textoCentrado navActiveButton ActivarRojo ActivarMenuItem' })
            this.setState({ errors: error });
            validador = false;
        }
        if (this.state.DestinodelCredito == "") {
            error["Error_DestinodelCredito"] = "Debe seleccionar una opción.";
            this.setState({ validadorTab4Class: 'textoCentrado navActiveButton ActivarRojo ActivarMenuItem' })
            this.setState({ errors: error });
            validador = false;
        }

        if (this.state.YearsResidence == 0 || this.state.YearsResidence == "" || isNaN(this.state.YearsResidence) == true) {
            error["Error_YearsResidence"] = "Debe ingresar un monto mayor a 0";
            this.setState({ validadorTab2Class: 'textoCentrado navActiveButton ActivarRojo ActivarMenuItem' })
            this.setState({ errors: error });
            validador = false;
        }
        if (this.state.IngresosDeclaradosMensuales == 0 || this.state.IngresosDeclaradosMensuales == "" || isNaN(this.state.IngresosDeclaradosMensuales) == true) {
            error["Error_IngresosDeclaradosMensuales"] = "Debe ingresar un monto mayor a 0";
            this.setState({ errors: error });
            validador = false;
        }

        if (this.state.MontoSolicitado == 0 || this.state.MontoSolicitado == "" || isNaN(this.state.MontoSolicitado) == true) {
            error["Error_MontoSolicitado"] = "Debe ingresar un monto mayor a 0";
            this.setState({ errors: error });
            validador = false;
        }

        if (this.state.NumeroParcialidades == 0 || this.state.NumeroParcialidades == "" || isNaN(this.state.NumeroParcialidades) == true) {
            error["Error_NumeroParcialidades"] = "Debe ingresar un monto mayor a 0";
            this.setState({ errors: error });
            validador = false;
        }
        if (this.state.MontoPosibleApagar == 0 || this.state.MontoPosibleApagar == "" || isNaN(this.state.MontoPosibleApagar) == true) {
            error["Error_MontoPosibleApagar"] = "Debe ingresar un monto mayor a 0";
            this.setState({ errors: error });
            validador = false;
        }

       

        if (validador) {

            this.setState({
                mensajeModal: "ValidarSMS"

            })
            this.setState({
                modal: true

            })
           
            
        } else {
          //  alert('Por favor, verifique el formulario')



           
            console.log(this.state)
            this.setState({
                mensajeModal: 'Por favor, verifique el formulario'

            })

            this.setState({
                modal: true

            })
        }
     
    }

    sendDataServer = () => {

        this.setState({ errors: {} });
        console.log('validation successful')
        console.log(this.state)

        this.UpdateCredito("ENVIADA");
    }



    addCredito(estadoSolicitud){
      console.log(estadoSolicitud); 
        const solicitud = {
            Id: parseInt(0),
            UserId: this.state.UserId
        };
        const address = {
            IdSolicitud: 0,
           
            AddressDetail: this.state.AddressDetail,
            CologneFractionation: this.state.CologneFractionation,
            City: this.state.City,
            NumExt: this.state.NumExt,
            NumInt: this.state.NumInt,
            PostalCode: this.state.PostalCode,
            DelegationMunicipality: this.state.DelegationMunicipality,
            State: this.state.State,
            Cellphone: this.state.Cellphone2,
            TypeHousing: this.state.TypeHousing,
            YearsResidence: parseInt(this.state.YearsResidence.toString())


        };
        const credito = {
            IdSolicitud: 0,
            MontoSolicitado:parseFloat(this.state.MontoSolicitado.toString()),
            NumeroParcialidades: parseFloat(this.state.NumeroParcialidades.toString()),
            MontoPosibleApagar: parseFloat(this.state.MontoPosibleApagar.toString()),
          UsoCredito: this.state.UsoCredito,
            Estado: estadoSolicitud,
            DestinodelCredito: this.state.DestinodelCredito,
            OtroDestinodelCredito: this.state.OtroDestinodelCredito,
          FechaModificacion: new Date()
        };

        const laboral = {
            IdSolicitud: 0,
            Empleador: this.state.Empleador,
            TipodeEmpleo: this.state.TipodeEmpleo,
           
            IngresosDeclaradosMensuales: parseFloat(this.state.IngresosDeclaradosMensuales.toString()),
            FechaIngreso: this.state.FechaIngreso
        };

        const referencias = {
            IdSolicitud: 0,
            NombreCompleto1: this.state.NombreCompleto1,
            Parentesco1: this.state.Parentesco1,
            TelfLd1: this.state.TelfLd1,
            Telefono1: this.state.Telefono1,
            TelfExt1: this.state.TelfExt1,
            NombreCompleto2: this.state.NombreCompleto2,
            Parentesco2: this.state.Parentesco2,
            TelfLd2: this.state.TelfLd2,
            Telefono2: this.state.Telefono2,
            TelfExt2: this.state.TelfExt2,
            NombreCompleto3: this.state.NombreCompleto3,
            Parentesco3: this.state.Parentesco3,
            TelfLd3: this.state.TelfLd3,
            Telefono3: this.state.Telefono3,
            TelfExt3: this.state.TelfExt3,
        };
        const demographic = {
            IdSolicitud: 0,
            MaximumDegreeStudies: this.state.MaximumDegreeStudies,
            MaritalStatus: this.state.MaritalStatus,
            SpousalRegime: this.state.SpousalRegime,
            NumEconomicDependents: this.state.NumEconomicDependents,
            FullNameSpouse: this.state.FullNameSpouse,
            OccupationSpouse: this.state.OccupationSpouse,
            BusinessSpouse: this.state.BusinessSpouse,
            CellphoneSpouse: this.state.CellphoneSpouse,
            CompanyPhoneSpouse: this.state.CompanyPhoneSpouse
        };

        var d = new Date()
        const ubicacion = {
            IdSolicitud: 0,
            Latitud: this.state.LatitudAPI,
            Longitud: this.state.LongitudAPI,
            Direccion: this.state.UbicacionAPI,
            InfoDevice: this.state.deviceUSer,
            Intentos: parseInt(this.state.Intentos),
            FechaVencimiento:  new Date()
        };

        const AspNetUsers = {
            IdSolicitud: 0,
            PhoneNumber: this.state.Telf_Particular

        };


        const obj = {
            solicitud: solicitud,
            credito: credito,
            laboral: laboral,
            referencias: referencias,
            address: address,
            demographic: demographic,
            ubicacion: ubicacion,
            AspNetUsers: AspNetUsers
        }
        console.log(obj)
        //carga de la solicitud
        axios.post('/Api/Credito/AddSolicitud/', obj).then(json => {
            console.log(json.data)
            //if (json.data.status === 'Success') {
               console.log(json.data.message);
            //    obj.credito.IdSolicitud = json.data.Message;
            
            this.setState({ ['Id']: json.data.id })
              // this.props.history.push('/VerCreditos')


         // this.uploadBlobByStreamR(e)
            //}
        
        }).catch(error => {
            console.log(error.response)
        });

      

  }
    handleChange = (e) => {
    //    this.ValidateForm();
        console.log(this.state)
        this.setState({ [e.target.name]: e.target.value });
        console.log(this.state)
    }
    handleChangeTabs =(value, name, props)=> {
    
        console.log(this.state)
        this.setState({ [name]: value });
      
        console.log(this.state)
    }

    cambiarTelefono = () => {

        console.log(this.state)
        this.setState({ hidebtnEditartelf: false });
        
      //  alert('cambire telefono')
    }
    

    ValidarCodigoSMS = (props) => {

     

        //this.setState({ [name]: value });
        if (this.state.NumAleatorio.toString() == this.state.ValidadorSMS.toString()) {


            this.setState({ hideAprobado: false });
            this.setState({ hideEncurso: true });
            this.setState({ hidevalidateBTN: true });
            this.setState({ validateTableAlert: true });
            this.sendDataServer()
        } else {
            this.setState({ hideAprobado: true });
            this.setState({ hideEncurso: false });
            this.setState({ validateTableAlert: false });
            
        }
        //console.log(props)
    }


    GenerarCodigo = () => {


        this.setState({ NumAleatorio: Math.floor(Math.random() * (99999 - 10000 + 1)) + 10000 });
      

        console.log(this.state)
    }

    ReenviarCodigo = () => {
        this.setState({ validateTableAlert: true });
        if (parseInt(this.state.Intentos) <= 3) {
            this.setState({ hideinputSMS: false });
            this.setState({ hideTextSMS: false });
            
            this.setState({ hidetextSMS: true });
            this.setState({ hideBTNinputSMS: true }); 
            this.setState({ hidevalidateBTN: false });

            axios.get('GetSMS')
                .then(response => {

                    var SMSVar = response.data.split('|')
                 

                    axios.get('https://api1.calixtaondemand.com/Controller.php/__a/sms.send.remote.ol.sa?cte=' + SMSVar[0] + '&encpwd=' + SMSVar[2] + '&email=' + SMSVar[1]+'&mtipo=SMS&' +
                        'numtel=' + this.state.Telf_Particular + '&msg=MaxCapitalMex: código de autorización para tu solicitud de crédito ' + this.state.NumAleatorio + '&json=1&auxiliar=Prueba_EIGO_V1')
                        .then(response => {


                            // console.log(response)

                        })
                        .catch(function (error) {
                            console.log(error);
                        })
                })
                .catch(function (error) {
                    console.log(error);
                })

            

            if (this.state.mensajeModal == 'Volver a solicitar el codigo') {
           
               
                this.setState({ Intentos: parseInt(this.state.Intentos) + 1 });
               
               
            }
            else {
                this.setState({ MensajeValidador: 'Volver a solicitar el codigo' });
                this.setState({ Intentos: parseInt(this.state.Intentos) + 1 });

               

            }




            if (this.state.Id == 0) {
                this.addCredito("GUARDADO");

            } else {

                this.UpdateCreditoSMS("GUARDADO");
            }


         //   alert('el codigo ha sido enviado de nuevo ' + this.state.NumAleatorio)




            console.log(this.state)
        }
        else {

            this.setState({ hidebtnEditartelf: true });
            this.setState({ hideTextSMS: true });
            this.setState({ hideBTNinputSMS: true });
            this.setState({ hideinputSMS: true });
            this.setState({ hidetextSMS: false });
            this.setState({ hidevalidateBTN: true });
            alert('limite de sms')
        }

       
    }


    
    handleCheck = () => {
        this.setState({ aceptarCondiciones: !this.state.aceptarCondiciones });
    } 
    handleCheckCartaPoder = () => {
        this.setState({ CartaPoder: !this.state.CartaPoder });
        this.setState({ ['StatusCartapoder']: this.state.CartaPoder })
     


    }

    AlertaInfoUbicacion = () => {
        this.setState({
            mensajeModal: "Ubicacion"

        })

        this.setState({
            modal: true

        })
    }
    UbicarPesona = () => {
        var Mensaje = "";
        this.getUserDeviceInfo()

        var options = {
            enableHighAccuracy: true,
            timeout: 5000,
            maximumAge: 0
        };

        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(function (position) {

                axios.get('https://dev.virtualearth.net/REST/v1/Locations/' + position.coords.latitude + ',' + position.coords.longitude + '?o=xml&key=AhrHjF0RNB05-QXa2Y0h386L_Gve6uWp9LK86-Gu7FqjLwCXqsbaBoCWAuC9m_DD').then(response => {

                    console.log('https://dev.virtualearth.net/REST/v1/Locations/' + position.coords.latitude + ',' + position.coords.longitude + '?o=xml&key=AhrHjF0RNB05-QXa2Y0h386L_Gve6uWp9LK86-Gu7FqjLwCXqsbaBoCWAuC9m_DD')
                    console.log(response.data)

                    var parser = new DOMParser();
                    var xmlDoc = parser.parseFromString(response.data, "text/xml");;
                    var busquedaFormatedText = 2
                    if (xmlDoc.childNodes[0].childNodes[6].childNodes[0].childNodes[1].childNodes[0].childNodes[4].childNodes[2].nodeName == 'FormattedAddress') {
                        busquedaFormatedText = 2
                    } else if (xmlDoc.childNodes[0].childNodes[6].childNodes[0].childNodes[1].childNodes[0].childNodes[4].childNodes[3].nodeName == 'FormattedAddress') {
                        busquedaFormatedText = 3
                    }
                 
                    var Mensaje = "<b>Latitud</b></br>" + position.coords.latitude + "</br>" +
                        "<b>Longitud</b></br>" + position.coords.longitude + "</br>" +
                        //"<b>" + xmlDoc.childNodes[0].childNodes[6].childNodes[0].childNodes[1].childNodes[0].childNodes[4].childNodes[0].nodeName + "</b></br>" + xmlDoc.childNodes[0].childNodes[6].childNodes[0].childNodes[1].childNodes[0].childNodes[4].childNodes[0].textContent + "</br>" +
                        //"<b>" +  xmlDoc.childNodes[0].childNodes[6].childNodes[0].childNodes[1].childNodes[0].childNodes[4].childNodes[1].nodeName + "</b></br>" + xmlDoc.childNodes[0].childNodes[6].childNodes[0].childNodes[1].childNodes[0].childNodes[4].childNodes[1].textContent + "</br>" +
                        //"<b>" +  xmlDoc.childNodes[0].childNodes[6].childNodes[0].childNodes[1].childNodes[0].childNodes[4].childNodes[2].nodeName + "</b></br>" + xmlDoc.childNodes[0].childNodes[6].childNodes[0].childNodes[1].childNodes[0].childNodes[4].childNodes[2].textContent + "</br>" +

             
                        "<b>Dirección</b></br>" + xmlDoc.childNodes[0].childNodes[6].childNodes[0].childNodes[1].childNodes[0].childNodes[4].childNodes[busquedaFormatedText].textContent;


                    console.log(Mensaje)
                    window.UbicacionPersona = Mensaje

                    document.getElementById('LongitudAPI').value = position.coords.longitude

                    document.getElementById('LatitudAPI').value = position.coords.latitude
                    
                    document.getElementById('UbicacionAPI').value = xmlDoc.childNodes[0].childNodes[6].childNodes[0].childNodes[1].childNodes[0].childNodes[4].childNodes[3].textContent;
                    document.getElementById('UbicacionAPIText').innerHTML = Mensaje

                    document.getElementById('mapaAPI').src = "https://www.bing.com/maps/embed?h=400&w=500&cp=" + position.coords.latitude +"~" + position.coords.longitude+"&lvl=11&typ=s&sty=r&src=SHELL&FORM=MBEDV8"

                })
                    .catch(function (error) {
                        console.log(error);
                    })
               


            },
                function (error) {

                    alert("No se puede acceder a su ubicacion. Por favor, verifique los permisos.-" + error.message)
                    console.log(error)
                }, options)

            

        }

        else {
            console.log = "Geolocation is not supported by this browser.";
        }

    }
   
  

    refreshBlobListR = () => {
        
      //  window.refreshBlobList(this.state.UserId)
        
    }

    UpdateCredito(estadoSolicitud) {

        const solicitud = {

            Id: this.state.Id,
            UserId: this.state.UserId
        };
        const address = {
            IdSolicitud: this.state.Id,

            AddressDetail: this.state.AddressDetail,
            CologneFractionation: this.state.CologneFractionation,
            City: this.state.City,
            NumExt: this.state.NumExt,
            NumInt: this.state.NumInt,
            PostalCode: this.state.PostalCode,
            DelegationMunicipality: this.state.DelegationMunicipality,
            State: this.state.State,
            Cellphone: this.state.Cellphone2,
            TypeHousing: this.state.TypeHousing,
            YearsResidence: parseInt(this.state.YearsResidence.toString())


        };
        const credito = {
            IdSolicitud: this.state.Id,
            MontoSolicitado: parseFloat(this.state.MontoSolicitado.toString()),
            NumeroParcialidades: parseFloat(this.state.NumeroParcialidades.toString()),
            MontoPosibleApagar: parseFloat(this.state.MontoPosibleApagar.toString()),
            UsoCredito: this.state.UsoCredito,
            Estado: estadoSolicitud,
            DestinodelCredito: this.state.DestinodelCredito,
            OtroDestinodelCredito: this.state.OtroDestinodelCredito,
            FechaModificacion: new Date()
        };
        const laboral = {
            IdSolicitud: this.state.Id,
            Empleador: this.state.Empleador,
            TipodeEmpleo: this.state.TipodeEmpleo,
         
            IngresosDeclaradosMensuales: parseFloat(this.state.IngresosDeclaradosMensuales.toString()),
            FechaIngreso: this.state.FechaIngreso
        };
        const referencias = {
            IdSolicitud: this.state.Id,
            NombreCompleto1: this.state.NombreCompleto1,
            Parentesco1: this.state.Parentesco1,
            TelfLd1: this.state.TelfLd1,
            Telefono1: this.state.Telefono1,
            TelfExt1: this.state.TelfExt1,
            NombreCompleto2: this.state.NombreCompleto2,
            Parentesco2: this.state.Parentesco2,
            TelfLd2: this.state.TelfLd2,
            Telefono2: this.state.Telefono2,
            TelfExt2: this.state.TelfExt2,
            NombreCompleto3: this.state.NombreCompleto3,
            Parentesco3: this.state.Parentesco3,
            TelfLd3: this.state.TelfLd3,
            Telefono3: this.state.Telefono3,
            TelfExt3: this.state.TelfExt3,
        };
        const demographic = {
            IdSolicitud: this.state.Id,
            MaximumDegreeStudies: this.state.MaximumDegreeStudies,
            MaritalStatus: this.state.MaritalStatus,
            SpousalRegime: this.state.SpousalRegime,
            NumEconomicDependents: this.state.NumEconomicDependents,
            FullNameSpouse: this.state.FullNameSpouse,
            OccupationSpouse: this.state.OccupationSpouse,
            BusinessSpouse: this.state.BusinessSpouse,
            CellphoneSpouse: this.state.CellphoneSpouse,
            CompanyPhoneSpouse: this.state.CompanyPhoneSpouse
        };

        var d = new Date()
        const ubicacion = {
            IdSolicitud: this.state.Id,
            Latitud: this.state.LatitudAPI,
            Longitud: this.state.LongitudAPI,
            Direccion: this.state.UbicacionAPI,
            InfoDevice: this.state.deviceUSer,
            Intentos: parseInt(this.state.Intentos),
            FechaVencimiento:  new Date()
        };

        const AspNetUsers = {
            IdSolicitud: this.state.Id,
            PhoneNumber: this.state.Telf_Particular

        };

        const obj = {
            solicitud: solicitud,
            credito: credito,
            laboral: laboral,
            referencias: referencias,
            address: address,
            demographic: demographic,
            ubicacion: ubicacion,
            AspNetUsers: AspNetUsers
        }
        console.log(obj)
       
        axios.put('/Api/Credito/UpdateSolicitud/', obj)
            .then(json => {
                console.log(json.data)
             //   this.props.history.push('/VerCreditos')

                if (json.data.status === "Updated") {
                    console.log(json.data.Message);
                    obj.credito.IdSolicitud = json.data.Message;

                    if (estadoSolicitud == "GUARDADO") {
                        this.props.history.push('/VerCreditos')
                    }
                    //  
                  // 


                }
            }).catch(function (error) {
                console.log(error);
            })





    }

    UpdateCreditoSMS(estadoSolicitud) {

        const solicitud = {

            Id: this.state.Id,
            UserId: this.state.UserId
        };
        const address = {
            IdSolicitud: this.state.Id,

            AddressDetail: this.state.AddressDetail,
            CologneFractionation: this.state.CologneFractionation,
            City: this.state.City,
            NumExt: this.state.NumExt,
            NumInt: this.state.NumInt,
            PostalCode: this.state.PostalCode,
            DelegationMunicipality: this.state.DelegationMunicipality,
            State: this.state.State,
            Cellphone: this.state.Cellphone2,
            TypeHousing: this.state.TypeHousing,
            YearsResidence: parseInt(this.state.YearsResidence.toString())


        };
        const credito = {
            IdSolicitud: this.state.Id,
            MontoSolicitado: parseFloat(this.state.MontoSolicitado.toString()),
            NumeroParcialidades: parseFloat(this.state.NumeroParcialidades.toString()),
            MontoPosibleApagar: parseFloat(this.state.MontoPosibleApagar.toString()),
            UsoCredito: this.state.UsoCredito,
            Estado: estadoSolicitud,
            DestinodelCredito: this.state.DestinodelCredito,
            OtroDestinodelCredito: this.state.OtroDestinodelCredito,
            FechaModificacion: new Date()
        };
        const laboral = {
            IdSolicitud: this.state.Id,
            Empleador: this.state.Empleador,
            TipodeEmpleo: this.state.TipodeEmpleo,

            IngresosDeclaradosMensuales: parseFloat(this.state.IngresosDeclaradosMensuales.toString()),
            FechaIngreso: this.state.FechaIngreso
        };
        const referencias = {
            IdSolicitud: this.state.Id,
            NombreCompleto1: this.state.NombreCompleto1,
            Parentesco1: this.state.Parentesco1,
            TelfLd1: this.state.TelfLd1,
            Telefono1: this.state.Telefono1,
            TelfExt1: this.state.TelfExt1,
            NombreCompleto2: this.state.NombreCompleto2,
            Parentesco2: this.state.Parentesco2,
            TelfLd2: this.state.TelfLd2,
            Telefono2: this.state.Telefono2,
            TelfExt2: this.state.TelfExt2,
            NombreCompleto3: this.state.NombreCompleto3,
            Parentesco3: this.state.Parentesco3,
            TelfLd3: this.state.TelfLd3,
            Telefono3: this.state.Telefono3,
            TelfExt3: this.state.TelfExt3,
        };
        const demographic = {
            IdSolicitud: this.state.Id,
            MaximumDegreeStudies: this.state.MaximumDegreeStudies,
            MaritalStatus: this.state.MaritalStatus,
            SpousalRegime: this.state.SpousalRegime,
            NumEconomicDependents: this.state.NumEconomicDependents,
            FullNameSpouse: this.state.FullNameSpouse,
            OccupationSpouse: this.state.OccupationSpouse,
            BusinessSpouse: this.state.BusinessSpouse,
            CellphoneSpouse: this.state.CellphoneSpouse,
            CompanyPhoneSpouse: this.state.CompanyPhoneSpouse
        };

        var d = new Date()
        const ubicacion = {
            IdSolicitud: this.state.Id,
            Latitud: this.state.LatitudAPI,
            Longitud: this.state.LongitudAPI,
            Direccion: this.state.UbicacionAPI,
            InfoDevice: this.state.deviceUSer,
            Intentos: parseInt(this.state.Intentos),
            FechaVencimiento: new Date()
        };

        const AspNetUsers = {
            IdSolicitud: this.state.Id,
            PhoneNumber: this.state.Telf_Particular

        };

        const obj = {
            solicitud: solicitud,
            credito: credito,
            laboral: laboral,
            referencias: referencias,
            address: address,
            demographic: demographic,
            ubicacion: ubicacion,
            AspNetUsers: AspNetUsers
        }
        console.log(obj)

        axios.put('/Api/Credito/UpdateSolicitud/', obj)
            .then(json => {
                console.log(json.data)
                //   this.props.history.push('/VerCreditos')

                if (json.data.status === "Updated") {
                    console.log(json.data.Message);
                    obj.credito.IdSolicitud = json.data.Message;

                  
                    //  
                    // 


                }
            }).catch(function (error) {
                console.log(error);
            })





    }
    uploadBlobByStreamR = (e) => {
        console.log(this.state.UserId)
        console.log(this.state.Id)
        console.log(e.target.value)
        
        console.log(this.state.Id)


    }

    CerrarModalFinal = () => {

        this.props.history.push('/VerCreditos')
    }
    
    displayProcessR = () => {
       
        window.displayProcess(0)
    }
    handleChangeDestinodelCredito = (value, name, props) => {

        this.setState({ [name]: value });
  
        if (value=="Otro") {

            this.setState({ ['hideOtroDestinodelCredito']: false })
        } else {

            this.setState({ ['hideOtroDestinodelCredito']: true })
           
        }
        console.log(this.state)

    }

    handleChangehideOtroTypeHousing = (value, name, props) => {

        this.setState({ [name]: value });
        if (value == "Otro") {

            this.setState({ ['hideOtroTypeHousing']: false })
        } else {

            this.setState({ ['hideOtroTypeHousing']: true })

        }

    }

    handleChangehidestatusEdoCivil = (value, name, props) => {

               this.setState({ [name]: value });
        if (value == "CASADO/A" || value == "CASADO / A") {

            this.setState({ ['statusEdoCivil']: false })
        } else {

            this.setState({ ['statusEdoCivil']: true })

        }

    }

    render() {
   

    return (
        <div className="App">
            <Form className="form">
           
              
                <h2 className="PageHeading" >Solicitud  de crédito</h2>

               <br/>
                <Tabs state={this.state} handleChangehidestatusEdoCivil={this.handleChangehidestatusEdoCivil}
                    handleChangehideOtroTypeHousing={this.handleChangehideOtroTypeHousing}
                    handleChangeDestinodelCredito={this.handleChangeDestinodelCredito}
                    handleChangeTabs={this.handleChangeTabs}
                    handleChangePostalCode={this.handleChangePostalCode}
                    handleChangeMontoPosibleApagar={this.handleChangeMontoPosibleApagar}
                    SaveValidateFormAdjunto={this.SaveValidateFormAdjunto}
                    displayProcessR={this.displayProcessR}
                    handleCheck={this.handleCheck}
                    handleCheckCartaPoder={this.handleCheckCartaPoder}
                    ValidateForm={this.ValidateForm}
                    SaveValidateForm={this.SaveValidateForm}
                    cancelarPantalla={this.cancelarPantalla}
                    UbicarPesona={this.UbicarPesona}
                    AlertaInfoUbicacion={this.AlertaInfoUbicacion}
                />  

                <ModalsAlert state={this.state}
                    CerrarModal={this.CerrarModal}
                    isOpen={this.state.modal}
                    sendDataServer={this.sendDataServer}
                    UbicarPesona={this.UbicarPesona}
                    handleChangeTabs={this.handleChangeTabs}
                    ValidarCodigoSMS={this.ValidarCodigoSMS}
                    ReenviarCodigo={this.ReenviarCodigo}
                    cambiarTelefono={this.cambiarTelefono}
                    CerrarModalFinal={this.CerrarModalFinal}
                />
            </Form> </div>
    );
  }
}
export default addCredito;


